export default "__VITE_ASSET__43ee816a__"